import script from "./artical_item.vue?vue&type=script&lang=ts&setup=true"
export * from "./artical_item.vue?vue&type=script&lang=ts&setup=true"

import "./artical_item.vue?vue&type=style&index=0&id=3ebff49b&lang=scss&scoped=true"
import "./artical_item.vue?vue&type=style&index=1&id=3ebff49b&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebff49b"]])

export default __exports__